import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import DashboardBooksetList from 'rebook/apps/dashboard/components/DashboardBooksetList';
import BooksetListEmpty from 'rebook/apps/base/components/BooksetListEmpty';
import fixQueryString from 'rebook/apps/utils/urls/fixQueryString';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';


class DashboardBooksetListBlock extends React.Component {
  constructor(props) {
    super(props);
    const { block } = props;
    const blockId = `${block.id}-${block.type}`;

    this.state = {
      block,
      blockId,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchBooksetList();
  }

  fetchBooksetList() {
    const { block, blockId } = this.state;
    const { dashboardBlockList } = this.props;

    if (dashboardBlockList[blockId]) {
      return null;
    }

    const url = fixQueryString(block.resource_uri, { booklimit: 0 });

    this.props.DashboardBlockListActions.fetchDashboardBlock(url, { apiVersion: 3 })
      .then(
        ({ data, dispatch }) => {
          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                booksets: data.objects,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard booksets due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;
    const booksets = get(dashboardBlockList[blockId], 'booksets.length', 0);

    const content = booksets === 0
      ? <BooksetListEmpty />
      : (
        <DashboardBooksetList
          title={this.state.block.title}
          booksets={dashboardBlockList[blockId].booksets} />
      );
    return content;
  };
};

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};

DashboardBooksetListBlock.propTypes = {
  block: PropTypes.shape({
    title: PropTypes.string,
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBooksetListBlock);
